import actions from './actions'

export default function CostConceptsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_COSTCONCEPT:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_COSTCONCEPT:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
        openModal: action.openModal,
      }
    case actions.RESET_COSTCONCEPT:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
        openModal: null,
      }
    case actions.NEW_COSTCONCEPT:
      return {
        ...state,
        editing: { costTypeID: 0 },
        loading: false,
        saveSuccess: false,
        openModal: true,
      }

    case actions.CREATE_COSTCONCEPT_RECIEVED ||
      actions.UPDATE_COSTCONCEPT_RECIEVED ||
      actions.DELETE_COSTCONCEPT_RECIEVED:
      return {
        ...state,
        editing: { costTypeID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    case actions.SAVE_COSTCONCEPT_RECIEVED:
      return {
        ...state,
        loading: false,
        saveSuccess: true,
        message: action.message,
        savedCostTypeID: action.result.value,
      }
    default:
      return state
  }
}
